const Widget = () => null;

export default Widget;
